// 引用api文件
import api from '../index';
/**
 * @author yangluyao
 * @date 2020-04-01
 * @Description: 执法规范
*/
// 获取执法规范列表
export function getspecificationList(data, success, failure, menuId) { return api.postFormData('hzf-admin/sys/enforcement/getPageList', data, success, failure, menuId); }
// 删除执法规范
export function delSpecification(data, success, failure, menuId) { return api.postFormData('hzf-admin/sys/enforcement/delete', data, success, failure, menuId); }
// 修改执法规范
export function editSpecification(data, success, failure, menuId) { return api.postFormData('hzf-admin/sys/enforcement/update', data, success, failure, menuId); }
// 新建执法规范
export function saveSpecification(data, success, failure, menuId) { return api.postFormData('hzf-admin/sys/enforcement/save', data, success, failure, menuId); }
